import { createMenuService } from '../application/services/MenuService';
import { MenuRepositoryAdapter } from '../infra/adapters/menuRepository.adapter';
import { baseBuild } from '@/core/services/network/config/baseBuild';
import type { AppDispatch } from '@/app/store/store';

/**
 * Menu Feature Builder
 * Factory function to wire infrastructure -> application layer
 * This is where dependency injection happens
 * 
 * Wires:
 * - Menu repository adapter (infrastructure)
 * - Menu service (application)
 */
export function menuBuild(dispatch: AppDispatch) {
  return baseBuild(
    (dispatch) => new MenuRepositoryAdapter(dispatch),
    (repo) => createMenuService(repo),
    dispatch
  );
}

